function Config () {
}
Config.prototype = {
  cookieTimeOut: 120000,
  tokenKey: 'skynet_token',
  // baseHost: 'http://localhost:8088/itrans',
  baseHost: '.',
  isDebug: true,
  task: '/api/ocr/v1/task',
  dependencies: '/api/v1/dependencies'
}
var config = new Config()
export default config
